import { CSSProperties } from "react";
import { Column } from "react-table-8.10.7";

export const getPinnedShadowClass = <T>(column: Column<T>): CSSProperties => {
  if (column.getIsPinned() === "left") {
    return { boxShadow: "t-drop-shadow-table-left-pin" };
  }
  if (column.getIsPinned() === "right") {
    return { boxShadow: "t-drop-shadow-table-right-pin" };
  }
  return {};
};
